export default "__VITE_ASSET__Beb5iBzu__"